var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "tm-nav", class: { "tm-nav--hero": _vm.hero } },
    [
      _c(
        "div",
        { staticClass: "tm-nav__content container" },
        [
          _c(
            "router-link",
            { staticClass: "tm-nav__logo", attrs: { to: "/" } },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/logo-white.svg"),
                  alt: "tamsin.io"
                }
              })
            ]
          ),
          _c(
            "ul",
            { staticClass: "tm-nav__links" },
            _vm._l(_vm.links, function(link) {
              return _c(
                "li",
                { key: link.label },
                [
                  _c(
                    "router-link",
                    { staticClass: "tm-nav__link", attrs: { to: link.link } },
                    [_vm._v(_vm._s(link.label))]
                  )
                ],
                1
              )
            }),
            0
          ),
          _c(
            "button",
            {
              staticClass: "tm-nav__menu",
              attrs: {
                type: "button",
                "aria-controls": "tm-shelf",
                "aria-expanded": "false"
              },
              on: { click: _vm.onShelfOpen }
            },
            [
              _c(
                "i",
                {
                  staticClass: "material-icons-round",
                  attrs: { "aria-hidden": "true" }
                },
                [_vm._v("menu")]
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }